/*
 * Validation for gps lat or lng field
 */

app.directive('latValidation', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, el, attrs, ngModel) {
            function validate(val) {
                var valid = (isFinite(val) && Math.abs(val) <= 90);
                ngModel.$setValidity('lat', valid);
                return val;
            }
            ngModel.$parsers.push(validate);
        }
    };
});

app.directive('lngValidation', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, el, attrs, ngModel) {
            function validate(val) {
                var valid = (isFinite(val) && Math.abs(val) <= 180);
                ngModel.$setValidity('lng', valid);
                return val;
            }
            ngModel.$parsers.push(validate);
        }
    };
});
